<template>
  <main class="grid gap-x-4 gap-y-6 py-8 container md:grid md:cols-2 md:place-items-center">
    <div class="lg:max-w-4/5">
      <cms-section v-if="eSpots[0]" class="mb-8" :section="eSpots[0]" />
      <cms-section v-if="eSpots[1]" :section="eSpots[1]" />
      <form-newsletter
        class-heading="<md:text-center"
        class-subheading="<md:text-center"
        form-location="inline:body:none:hero-image"
        hide-heading
        hide-subheading
      >
        <template v-if="$feature.tblCtaLabelOfTheNewsletterSubsPage" #submitLabel>
          {{ $feature.tblCtaLabelOfTheNewsletterSubsPage }}
        </template>
      </form-newsletter>
      <cms-section v-if="eSpots[2]" class="mt-8" lazy-media :section="eSpots[2]" />
    </div>
    <cms-section v-if="eSpots[3]" lazy-media :section="eSpots[3]" />
  </main>
</template>

<script lang="ts" setup>
const eSpots = (await useCms().getSections.generic('newsletter-subscription')).data.value?.content?.sections ?? []
</script>
